import { Link } from "react-router"

export default function Card(props: any) {
  return (
    <div className="w-80 m-5 flex flex-col items-center md:w-96">
      <img src={props.image} className="w-full h-60 object-cover" alt="Beach Point Maragogi"/>
      <h3 className="text-xl text-center p-6 text-emerald-500 font-semibold">{props.title}</h3>
      <Link to={props.href} className="block bg-emerald-500 w-full text-center text-white p-2 font-semibold">
        Ver mais
      </Link>
    </div>
  )
}